import { Box, HStack, Icon, IconButton, Text, VStack } from "@chakra-ui/react";
import { ArrowLeft } from "@phosphor-icons/react";
import React from "react";
import { iconSize } from "../const/sizes";
import { Link } from "react-router-dom";

type Props = {
  la?: any | undefined;
  backLink?: string;
  label?: string | undefined;
  ra?: any | undefined;
};

export default function NavHeader({ backLink, la, label, ra }: Props) {
  return (
    <HStack
      position={"fixed"}
      top={0}
      left={0}
      px={4}
      pl={"calc(60px + 16px)"}
      w={"100%"}
      h={"50px"}
      justify={"space-between"}
      borderBottom={"1px solid var(--divider3)"}
      bg={"whiteAlpha.900"}
      backdropFilter={"blur(5px)"}
      zIndex={97}
    >
      <Box w={"40px"}>
        {la !== "back" && la}

        {la === "back" && (
          <IconButton
            aria-label="leftActionButton"
            icon={<Icon as={ArrowLeft} fontSize={iconSize} />}
            className="btn-clear clicky"
            onClick={() => {
              window.history.back();
            }}
          />
        )}

        {backLink && (
          <IconButton
            aria-label="leftActionButton"
            icon={<Icon as={ArrowLeft} fontSize={iconSize} />}
            className="btn-clear clicky"
            as={Link}
            to={backLink}
          />
        )}
      </Box>

      <Box flex={1}>
        <Text fontWeight={600} textAlign={"center"} noOfLines={1}>
          {label}
        </Text>
      </Box>

      <VStack w={"40px"} align={"flex-end"}>
        {ra && ra}
      </VStack>
    </HStack>
  );
}
